function handleSearchLabel() {
    document.querySelectorAll(".search__input").forEach((e) => {
        const t = e.parentElement.querySelector(".field__label");
        t &&
            ("" !== e.value.trim()
                ? ((t.style.opacity = "0"), (t.style.visibility = "hidden"))
                : ((t.style.opacity = "1"), (t.style.visibility = "visible")));
    });
}
document.addEventListener("DOMContentLoaded", function () {
    const e = document.querySelector(".custom-notice-bar .close-icon");
    e &&
        e.addEventListener("click", function () {
            document.querySelector(".custom-notice-bar").style.display = "none";
        });
}),
    document.addEventListener("DOMContentLoaded", function () {
        var e = document.getElementById("locationSelect"),
            t = document.getElementById("deliveryTime");
        function n() {
            var n = e.options[e.selectedIndex];
            t.textContent = n.getAttribute("data-delivery") || "";
        }
        e.options.length > 0 && ((e.selectedIndex = 0), n()), e.addEventListener("change", n);
    }),
    $(document).ready(function () {
        let e;
        function t() {
            const e = $(window).width(),
                t = $(".cus-prodct-tab-content.active .cus-prodct-tab-products");
            0 !== t.length &&
                (e <= 990 && !t.hasClass("slick-initialized")
                    ? t.slick({ slidesToShow: 2.3, slidesToScroll: 1, infinite: !1, arrows: !1, dots: !1 })
                    : e > 990 && t.hasClass("slick-initialized") && t.slick("unslick"));
        }
        t(),
            $(window).on("resize", function () {
                clearTimeout(e), (e = setTimeout(t, 200));
            }),
            document.addEventListener("shopify:section:load", function (e) {
                t();
            }),
            document.querySelectorAll(".cus-prodct-tab-wrap").forEach(function (e) {
                const n = e.querySelectorAll(".cus-prodct-tab-link"),
                    o = e.querySelectorAll(".cus-prodct-tab-content");
                n.forEach(function (i) {
                    i.addEventListener("click", function () {
                        const i = this.getAttribute("data-tab");
                        n.forEach((e) => e.classList.remove("active")),
                            o.forEach((e) => e.classList.remove("active")),
                            this.classList.add("active");
                        e.querySelector("#" + i).classList.add("active"), setTimeout(t, 50);
                    });
                });
            });
    }),
    document.addEventListener("DOMContentLoaded", function () {
        const e = document.querySelector(".custom-filter-drawer"),
            t = document.getElementById("product-grid");
        function n(e) {
            if (!e) return !1;
            const t = e.getBoundingClientRect();
            return t.top < window.innerHeight && t.bottom > 0;
        }
        function o() {
            const o = document.querySelector(".facets-custom-design-element");
            if (!e || !t) return;
            const i = n(t),
                c = n(o);
            e.style.display = i && !c ? "flex" : "none";
        }
        e &&
            e.addEventListener("click", function () {
                const e = document.querySelector(".mobile-facets__open-wrapper");
                e && e.click();
            }),
            o(),
            window.addEventListener("scroll", o),
            window.addEventListener("resize", o);
    }),
    document.addEventListener("DOMContentLoaded", function () {
        document.querySelector(".custom-mobile-facets__close")?.addEventListener("click", function () {
            document.querySelector(".mobile-facets__close")?.click();
        });
    }),
    $(document).ready(function () {
        function e() {
            $(window).width() <= 1220
                ? $(".explore_top_brands_blocks-slider").hasClass("slick-initialized") ||
                  $(".explore_top_brands_blocks-slider").slick({
                      infinite: !0,
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      responsive: [{ breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } }],
                  })
                : $(".explore_top_brands_blocks-slider").hasClass("slick-initialized") &&
                  $(".explore_top_brands_blocks-slider").slick("unslick");
        }
        let t = 0;
        function n() {
            $(".related-product-custom-slider").length
                ? $(window).width() <= 1220
                    ? $(".related-product-custom-slider").hasClass("slick-initialized") ||
                      $(".related-product-custom-slider").slick({
                          infinite: !1,
                          slidesToShow: 2.2,
                          slidesToScroll: 1,
                          responsive: [{ breakpoint: 768, settings: { slidesToShow: 2.2, slidesToScroll: 1 } }],
                      })
                    : $(".related-product-custom-slider").hasClass("slick-initialized") &&
                      $(".related-product-custom-slider").slick("unslick")
                : t < 10 && (t++, setTimeout(n, 300));
        }
        e(),
            n(),
            $(window).on("resize", function () {
                e(), n();
            }),
            document.addEventListener("shopify:section:load", function (t) {
                e(), n();
            });
    }),
    document.addEventListener("DOMContentLoaded", function () {
        const e = document.querySelector(".sticky-add-to-cart"),
            t = document.querySelector(".product-form__submit");
        function n() {
            if (!t || !e) return;
            const n = t.getBoundingClientRect();
            (n.bottom < 0 || n.top > window.innerHeight) && window.scrollY > n.top
                ? e.classList.add("visible")
                : e.classList.remove("visible");
        }
        e &&
            (document.querySelector(".sticky-atc-btn").addEventListener("click", function () {
                t && t.click();
            }),
            document.querySelector(".sticky-checkout-btn").addEventListener("click", function () {
                let e = document.querySelector(".shopify-payment-button button");
                e || (e = document.querySelector("more-payment-options-link a")), e && e.click();
            }),
            window.addEventListener("scroll", n),
            window.addEventListener("load", n),
            n());
    }),
    document.addEventListener("DOMContentLoaded", function () {
        const e = document.querySelector(".sticky-add-to-cart");
        if (!e) return;
        const t = e.querySelector(".sticky-additional-checkout-buttons"),
            n = e.querySelector(".sticky-checkout-btn");
        if (!t) return;
        function o() {
            t.querySelector("shopify-apple-pay-button") &&
                (n && n.remove(), e.classList.add("sticky-add-to-cart-with-apple-pay-btn"));
        }
        o();
        new MutationObserver(() => {
            o();
        }).observe(t, { childList: !0, subtree: !0 });
    }),
    document.addEventListener("DOMContentLoaded", function () {
        const e = document.querySelector("#title-filter-input");
        function t() {
            if (!e) return;
            const t = e.value.toLowerCase().trim();
            document.querySelectorAll("ul#product-grid > li.grid__item").forEach((e) => {
                const n = e.querySelector(".card__content .card__information .card__heading p.full-unstyled-link");
                if (!n) return;
                n.innerText.toLowerCase().includes(t) ? (e.style.display = "") : (e.style.display = "none");
            });
        }
        e && e.addEventListener("input", t);
        const n = document.querySelector("ul#product-grid");
        if (n) {
            new MutationObserver(() => {
                t();
            }).observe(n, { childList: !0, subtree: !0 });
        }
    }),
    document.addEventListener("DOMContentLoaded", function () {
        const e = document.querySelector(".search-acc-btn"),
            t = document.querySelector(".search-acc-panel");
        e &&
            t &&
            (e.classList.add("active"),
            (t.style.maxHeight = t.scrollHeight + "px"),
            e.addEventListener("click", function () {
                t.style.maxHeight
                    ? ((t.style.maxHeight = null), this.classList.remove("active"))
                    : ((t.style.maxHeight = t.scrollHeight + "px"), this.classList.add("active"));
            }));
    }),
    document.addEventListener("DOMContentLoaded", handleSearchLabel),
    document.addEventListener("input", function (e) {
        e.target.classList.contains("search__input") && handleSearchLabel();
    }),
    document.addEventListener("shopify:section:load", handleSearchLabel),
    document.addEventListener("shopify:section:unload", handleSearchLabel),
    document.addEventListener("shopify:section:select", handleSearchLabel),
    document.addEventListener("shopify:section:deselect", handleSearchLabel),
    (function () {
        function e(e, t, n) {
            return (e = parseInt(e, 10)), isNaN(e) && (e = t), Math.max(t, Math.min(n, e));
        }
        function t(t) {
            if ("1" !== t.dataset.priceSliderInit) {
                t.dataset.priceSliderInit = "1";
                var n = t.querySelector(".cus-lower"),
                    o = t.querySelector(".cus-upper"),
                    i = t.querySelector(".price-one"),
                    c = t.querySelector(".price-two");
                if (n && o && i && c) {
                    var r = (function (e) {
                            var t = e.closest("price-range");
                            if (t) return t;
                            for (var n = e.previousElementSibling; n; ) {
                                if (n.tagName && "price-range" === n.tagName.toLowerCase()) return n;
                                n = n.previousElementSibling;
                            }
                            return e.parentElement && (t = e.parentElement.querySelector("price-range")) ? t : null;
                        })(t),
                        s = null,
                        d = null;
                    if (r) {
                        var a = r.getAttribute("data-min-id"),
                            l = r.getAttribute("data-max-id");
                        a && (s = r.querySelector("#" + CSS.escape(a))),
                            l && (d = r.querySelector("#" + CSS.escape(l))),
                            s || (s = r.querySelector('input[id$="-GTE"]')),
                            d || (d = r.querySelector('input[id$="-LTE"]'));
                    }
                    var u = parseInt(n.min || "0", 10),
                        m = parseInt(n.max || o.max || "1000", 10);
                    f(n.value || u),
                        v(o.value || m),
                        n.addEventListener("input", function (e) {
                            f(e.target.value);
                        }),
                        o.addEventListener("input", function (e) {
                            v(e.target.value);
                        }),
                        i.addEventListener("change", function (e) {
                            f(e.target.value);
                        }),
                        c.addEventListener("change", function (e) {
                            v(e.target.value);
                        });
                }
            }
           function f(t) {
    (t = e(t, u, m - 4)) > parseInt(o.value, 10) - 4 && (t = parseInt(o.value, 10) - 4);
    n.value = t;
    i.value = t;
    if (s) {
        s.value = t;
        s.dispatchEvent(new Event('change', { bubbles: true }));
    }
}
function v(t) {
    (t = e(t, u + 4, m)) < parseInt(n.value, 10) + 4 && (t = parseInt(n.value, 10) + 4);
    o.value = t;
    c.value = t;
    if (d) {
        d.value = t;
        d.dispatchEvent(new Event('change', { bubbles: true }));
    }
}
        }
        function n(e) {
            (e || document).querySelectorAll(".custom-price-filter").forEach(t);
        }
        "loading" === document.readyState
            ? document.addEventListener("DOMContentLoaded", function () {
                  n();
              })
            : n(),
            (window.initCustomPriceFilters = n);
    })(),
    document.querySelector(".collection_description_read_more")?.addEventListener("click", function () {
        document.querySelector(".collection_description_info")?.classList.add("active"),
            (this.style.display = "none"),
            (document.querySelector(".collection_description_read_less").style.display = "inline-flex");
    }),
    document.querySelector(".collection_description_read_less")?.addEventListener("click", function () {
        document.querySelector(".collection_description_info")?.classList.remove("active"),
            (this.style.display = "none"),
            (document.querySelector(".collection_description_read_more").style.display = "inline-flex");
    }),
    document.addEventListener("input", function (e) {
        e.target.matches(".header--custom-design .search-modal__form .search__input") &&
            ("" !== e.target.value.trim()
                ? document.body.classList.add("overflow-hidden")
                : document.body.classList.remove("overflow-hidden"));
    }),
    document.addEventListener("click", function (e) {
        e.target.closest(".header--custom-design .search-modal__form .reset__button") &&
            document.body.classList.remove("overflow-hidden");
    });
const searchForm = document.querySelector(".header--custom-design .search-modal__form");
searchForm &&
    searchForm.addEventListener("reset", function () {
        document.body.classList.remove("overflow-hidden");
    });
const inlineMenu = document.querySelector(".header__inline-menu"),
    detailsItems = inlineMenu ? inlineMenu.querySelectorAll("details") : [];
detailsItems.forEach((e) => {
    let t;
    e.addEventListener("mouseenter", () => {
        clearTimeout(t), e.setAttribute("open", !0);
    }),
        e.addEventListener("mouseleave", () => {
            t = setTimeout(() => {
                e.removeAttribute("open");
            }, 100);
        });
}),
    (function () {
        var e = {},
            t = 40,
            n = 0;
        function o(o) {
            if (
                !(
                    ((i = navigator.connection || navigator.mozConnection || navigator.webkitConnection) &&
                        (i.saveData || (i.effectiveType && /2g/.test(i.effectiveType)))) ||
                    n >= t
                )
            ) {
                var i,
                    c = (function (e) {
                        try {
                            var t = new URL(e, window.location.origin);
                            return t.origin !== window.location.origin ||
                                (t.hash &&
                                    t.pathname === window.location.pathname &&
                                    t.search === window.location.search) ||
                                /\/cart($|\/)|\/checkout($|\/)|\/account($|\/)/.test(t.pathname)
                                ? null
                                : t.href;
                        } catch (e) {
                            return null;
                        }
                    })(o);
                if (c && !e[c]) {
                    (e[c] = !0), (n += 1);
                    var r = document.createElement("link");
                    (r.rel = "prefetch"), (r.href = c), (r.as = "document"), document.head.appendChild(r);
                }
            }
        }
        function i(e) {
            e &&
                "1" !== e.dataset.prefetchBound &&
                ((e.dataset.prefetchBound = "1"),
                e.addEventListener(
                    "mouseenter",
                    function () {
                        o(e.href);
                    },
                    { passive: !0 }
                ),
                e.addEventListener(
                    "touchstart",
                    function () {
                        o(e.href);
                    },
                    { passive: !0 }
                ),
                e.addEventListener(
                    "focus",
                    function () {
                        o(e.href);
                    },
                    { passive: !0 }
                ));
        }
        document.addEventListener("DOMContentLoaded", function () {
            !(function () {
                for (var e = document.querySelectorAll("a[href]"), t = 0; t < e.length; t++) i(e[t]);
            })();
        });
    })();



(function () {

  /* ========= NOTE TOGGLE ========= */
  function toggleNoteState() {
    const cartDrawer = document.querySelector('#CartDrawer');
    if (!cartDrawer) return;

    const noteField = cartDrawer.querySelector('#CartDrawer-Note');
    const addNote = cartDrawer.querySelector('.cart-tools__add-note');
    const editNote = cartDrawer.querySelector('.cart-tools__edit-note');

    if (!noteField || !addNote || !editNote) return;

    const hasValue = noteField.value.trim().length > 0;

    addNote.classList.toggle('hidden', hasValue);
    editNote.classList.toggle('hidden', !hasValue);
  }

  /* ========= CLICK HANDLER ========= */
  document.addEventListener('click', function (e) {

    const cartDrawer = document.querySelector('#CartDrawer');
    if (!cartDrawer) return;

    const trigger = e.target.closest('#CartDrawer [data-id]');
    const backBtn = e.target.closest('#CartDrawer .btn_back');

    const footerInner = cartDrawer.querySelector('.drawer__footer-inner');
    const toolsWrapper = cartDrawer.querySelector('.cart-tools');

    const sections = {
      note: cartDrawer.querySelector('#cart-note'),
      ship: cartDrawer.querySelector('#cart-ship'),
      dis: cartDrawer.querySelector('#cart-dis')
    };

    /* ========= OPEN ========= */
    if (trigger) {
      const type = trigger.getAttribute('data-id');

      Object.values(sections).forEach(el => el && el.classList.remove('active'));

      if (sections[type]) {
        sections[type].classList.add('active');
      }

      footerInner && footerInner.classList.add('hide');
      toolsWrapper && toolsWrapper.classList.add('hide');
    }

    /* ========= CLOSE ========= */
    if (backBtn) {
      Object.values(sections).forEach(el => el && el.classList.remove('active'));

      footerInner && footerInner.classList.remove('hide');
      toolsWrapper && toolsWrapper.classList.remove('hide');
    }

    /* ========= 🎯 KEY FIX (SAVE / CANCEL CLICK) ========= */
    const noteWrapper = e.target.closest('.drawer__footer-order-note');

    if (noteWrapper && e.target.classList.contains('btn_back')) {
      setTimeout(toggleNoteState, 50);
    }

  });

  /* ========= INPUT LIVE UPDATE ========= */
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'CartDrawer-Note') {
      toggleNoteState();
    }
  });

  /* ========= INITIAL LOAD ========= */
  document.addEventListener('DOMContentLoaded', function () {
    toggleNoteState();
  });

})();




$(document).ready(function() {
        var countrySelect = $('#address_country_ship');
        var includeUrl = countrySelect.data('include');
        var defaultCountry = countrySelect.data('default');

        if (includeUrl) {
          $.get(includeUrl, function(data) {
            countrySelect.html(data);
            if (defaultCountry) {
              countrySelect.val(defaultCountry);
            }
            if (typeof Shopify !== 'undefined') {
              new Shopify.CountryProvinceSelector('address_country_ship', 'address_province_ship', {
                hideElement: 'address_province_container_ship'
              });
            }
          });
        }

        $(document).on('click', '.get_rates', function() {
          var _this = $(this);
          var $wrapperId = $('#response_calcship');

          var shippingAddress = {
            zip: $('#address_zip_ship').val() || '',
            country: $('#address_country_ship').val() || '',
            province: $('#address_province_ship').val() || ''
          };

          if (!shippingAddress.country) {
            $wrapperId.html('<p style="color:red">Please select a country.</p>').fadeIn();
            return;
          }

          _this.prop('disabled', true).val('Calculating...');
          $wrapperId.empty().hide();

          $.ajax({
            type: 'POST',
            url: '/cart/shipping_rates.json',
            data: $.param({ shipping_address: shippingAddress }),
            success: function(response) {
              var rates = response.shipping_rates;

              if (!rates || rates.length === 0) {
                $wrapperId.html('<p>No shipping rates available.</p>').fadeIn();
                return;
              }

              var readable_address = '';
              if (shippingAddress.zip) readable_address += shippingAddress.zip + ', ';
              if (shippingAddress.province) readable_address += shippingAddress.province + ', ';
              readable_address += shippingAddress.country;

              var message = '';
              var firstPrice = moneyFormat(rates[0].price);

              if (rates.length > 1) {
                message = 'We found ' + rates.length + ' shipping rates available for ' + readable_address + ', starting at ' + firstPrice + '.';
              } else {
                message = 'We found one shipping rate available for ' + readable_address + '.';
              }

              var html = '<div class="shippingcalc_mess">' + message + '</div>';
              html += '<div class="shippingcalc_rate"><ul>';
              $.each(rates, function(i, rate) {
                html += '<li>' + rate.name + ' at ' + moneyFormat(rate.price) + '</li>';
              });
              html += '</ul></div>';

              $wrapperId.html(html).fadeIn();
            },
            error: function(xhr) {
              var msg = 'Could not get shipping rates.';
              try {
                var data = JSON.parse(xhr.responseText);
                if (data.message) msg = data.message;
              } catch(e) {}
              $wrapperId.html('<p style="color:red">' + msg + '</p>').fadeIn();
            },
            complete: function() {
              _this.prop('disabled', false).val('Calculate Shipping');
            }
          });
        });

        function moneyFormat(price) {
          var amount = parseFloat(price).toFixed(2);
          var currency = window.Shopify && Shopify.currency ? Shopify.currency.active : '';
          return currency + ' ' + amount;
        }

});

(function () {
const inputSel = '#Cartdiscode';
const saveSel = '.js_cart_save';
const key = 'cart_discount_code';

function code() {
    const el = document.querySelector(inputSel);
    return (el ? el.value : '').trim();
}

document.addEventListener('click', function (e) {
    // Save button
    if (e.target.closest(saveSel)) {
    const c = code();
    c ? localStorage.setItem(key, c) : localStorage.removeItem(key);
    }

    // Checkout button
    const checkoutBtn = e.target.closest('#CartDrawer [name="checkout"], #CartDrawer .cart__checkout-button');
    if (checkoutBtn) {
    const c = code() || (localStorage.getItem(key) || '').trim();
    if (c) {
        e.preventDefault();
        window.location.href = '/checkout?discount=' + encodeURIComponent(c);
    }
    }
});
})();

// mobile hamburger icon fixed js code 
function handleHamburgerFixed() {

    if ($(window).width() > 749) {
        $('.mobile-drawer-hamburger-menu').removeClass('make-fixed');
        $('.three-level-menu.three-level-menu-main').removeClass('has-hamburger');
        return;
    }

    const $header = $('.header--custom-design');
    const $menu = $('.header--custom-design .mobile-drawer-hamburger-menu');
    const $threeLevelMenu = $('.three-level-menu.three-level-menu-main');

    if (!$header.length || !$menu.length) return;

    const headerBottom = $header[0].getBoundingClientRect().bottom;

    if (headerBottom <= 0) {
        $menu.addClass('make-fixed');
        $threeLevelMenu.addClass('has-hamburger');
    } else {
        $menu.removeClass('make-fixed');
        $threeLevelMenu.removeClass('has-hamburger');
    }
}

$(window).on('scroll resize', function () {
    handleHamburgerFixed();
});

handleHamburgerFixed();